import {
	Component, EventEmitter, Input, Output, OnChanges, SimpleChanges, SimpleChange,
	ViewChildren, ViewChild, AfterViewInit, ElementRef, QueryList, ChangeDetectionStrategy,
	ChangeDetectorRef, OnInit, OnDestroy
} from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs/Rx';
import { DiscResultsService } from 'discovery';
import { IdentityService } from 'identity';
import { NavigationService } from 'netview';
import { MessageService } from 'base';
import {
	InfoSetView, InfoSetViewColumn, InfoSetViewEntry, InfoSetViewValue
} from 'UvExplorerServer.Dtos.TS/Session';
import { ReportViewerComponent, ReportsComponent } from 'infosets';


@Component({
	selector: 'admin-reports',
	templateUrl: './admin-reports.component.html',
	styleUrls: ['./admin-reports.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminReportsComponent implements OnInit, OnChanges, OnDestroy {

	public AssetInventoryReport = "asset-inventory-report";
	public DiscoveryAuditReport = "discovery-audit-report";
	public DeviceConnectivityReport = "device-connectivity-report";
	public SoftwareReport = "software-report";
	public ProcessesReport = "processes-report";
	public StalePortReport = "stale-port-report";
	public IpPhoneReport = "ip-phone-report";

	public selectedReport: string;
	public selectedReportInfo: InfoSetView;

	@ViewChild(ReportViewerComponent)
	public reportViewer: ReportViewerComponent;

	constructor(private discResultsService: DiscResultsService,
		private identityService: IdentityService,
		private navService: NavigationService,
		private messageService: MessageService,
		private changeDetector: ChangeDetectorRef) {

		this.selectedReport = "";
		this.selectedReportInfo = this.emptyInfoSetView();
	}

	public ngOnInit(): void {
		this.selectReport(this.AssetInventoryReport);
	}

	public ngOnChanges(changes: SimpleChanges): void {
		
	}

	public ngOnDestroy(): void {

	}

	public reloadReport(): void {
		if (this.reportViewer) {
			this.reportViewer.reloadReport();
		}
	}

	public selectReport(reportName: string): void {
		let sessionGuid = this.identityService.sessionGuid;
		let netViewGuid = this.navService.location.netViewGuid;
		let agentGuid = this.navService.location.agentGuid;
		let schedDiscGuid = this.navService.location.schedDiscGuid;
		let schedDiscRsltGuid = this.navService.location.schedDiscRsltGuid;

		if (!!sessionGuid && !!reportName) {
			this.discResultsService.getAdminReportView(sessionGuid, reportName).subscribe(
					(result: InfoSetView) => {
						this.selectedReport = reportName;
						this.selectedReportInfo = result;
						this.changeDetector.markForCheck();
					},
					(error?) => {
						this.messageService.displayErrorMessage("Could not retrieve the selected report");
					});
		}
	}

	private emptyInfoSetView(): InfoSetView {
		return {
			infoSetName: "",
			title: "",
			columns: [],
			entries: []
		};
	}

}
